<vw-check-row [checked]="checked" [label]="checkLabel" (check)="check.emit()" (open)="open.emit()">
  <span class="relative h-11 w-11 shrink-0">
    <img data-test="plant-action-thumb" [src]="imageUrl" alt="" class="h-full w-full rounded-field bg-vw-surface-tint object-cover" />
    <vw-action-badge class="absolute -right-1.5 -top-1.5" [ariaLabel]="'garden.overview.action-todo' | translate"></vw-action-badge>
  </span>
  <span class="min-w-0 flex-1" [class.opacity-60]="checked">
    <span data-test="plant-action-title" class="block truncate text-body font-semibold text-vw-ink" [class.line-through]="checked">{{ title }}</span>
    <span class="block truncate text-body-s text-vw-muted">{{ subtitle }}</span>
  </span>
</vw-check-row>
